
import Vue from 'vue';
import moment from 'moment';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import Button from '@/components/Button/index.vue';
import { sendEmail } from '@/services/email/send-email';
import Header from '@/components/HeaderInternal/index.vue';
import Modal from '@/components/ModalAddUser/index.vue';
import ModalDefault from '@/components/Modal/index.vue';
import Input from '@/components/Input/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import ResultMessage from '@/components/ResultMessage/index.vue';
import Table from '@/components/TableCustom/index.vue';
import Radio from '@/components/RadioButton/index.vue';
import ButtonCalender from '@/components/ButtonDate/index.vue';
import { getAll, GetVoucherParams, StatusInfoVoucher } from '@/services/voucher/get-all';
import { getAllVoucherAtive } from '@/services/voucher/get-all-voucher-ative';
import { getAllVoucherInative } from '@/services/voucher/get-all-voucher-inative';
import { getAllVoucherCadastration } from '@/services/voucher/get-all-voucher-reg';
import { getAllVoucherReg } from '@/services/voucher/get-all-voucher-reg-page';
import { getAllVoucher } from '@/services/voucher/get-all-voucher';
import { createVoucher, CreateVoucherBody } from '@/services/voucher/create';
import { deleteVoucher } from '@/services/voucher/delete';
import { VoucherEntity } from '@/config/types';
import showError from '@/handler/error';
import { capitalizeFirstLetter } from '@/utils/capitalize-first-letter';
import { removeMaskDocument } from '@/utils';
import { Main, ContentTable, ComponentButton } from './styles';

type VForm = Vue & { reset: () => void };

interface VoucherRquestParams extends Pick<GetVoucherParams, 'pageNumber' | 'pageSize' | 'status'> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  calback: (params: GetVoucherParams) => Promise<void>;
}

Vue.prototype.StatusInfoVoucher = StatusInfoVoucher;

export default Vue.extend({
  components: {
    Main,
    Table,
    Modal,
    Input,
    Button,
    ValidationObserver,
    ValidationProvider,
    Header,
    ResultMessage,
    Pagination,
    ContentTable,
    ComponentButton,
    ButtonCalender,
    Radio,
    ModalDefault,
  },
  data() {
    return {
      filter: StatusInfoVoucher.none,
      isOpenModal: false,
      click: false,
      codeVoucher: '',
      showConfirmModal: false,
      loading: false,
      email: '',
      ComponentKey: 0,
      openCalenderbool: false,
      size: 0,
      headers: [
        {
          key: 'code',
          value: 'Voucher',
          icon: true,
          hideOrder: true,
        },
        { key: 'nameProducer', value: 'Nome do Produtor', order: false },
        {
          key: 'activatedOn', value: 'Data de Criação', order: true, isStyle: true,
        },
        { key: 'expirationDate', value: 'Data de Expiração', order: false },
        {
          key: 'status',
          value: 'Situação',
          tag: true,
          hideOrder: true,
        },
        {
          key: 'option',
          value: 'Opções',
          iconDT: true,
          hideOrder: true,
        },
      ],
      data: [] as VoucherEntity[],
      voucher: {
        name: '',
        document: '',
        date: null,
      },
      allvoucher: 0,
      user: JSON.parse(sessionStorage.getItem('userLogged') as string),
      pagination: {
        offset: 1,
        pageSize: 10,
        total: 0,
      },
      infoVoucher: {
        used: 0,
        avaliable: 0,
      },
    };
  },
  computed: {
    form(): VForm {
      return this.$refs.form as VForm;
    },
    vouchers(): any[] {
      return this.data.map((voucher) => ({
        code: voucher.voucherCode,
        activatedOn: moment(voucher.activatedOn).format('L'),
        expirationDate: moment(voucher.expirationDate).format('L'),
        nameProducer: capitalizeFirstLetter(voucher.nameProducer),
        status: voucher.status,
        option: voucher.voucherCode + voucher.document,
      }));
    },
  },
  methods: {
    reset() {
      this.voucher = {
        name: '',
        document: '',
        date: null,
      };
    },
    removerItem(id) {
      const index = this.data.findIndex((item) => item.voucherCode === id);
      if (index !== -1) {
        this.data.splice(index, 1);
      }
    },
    async moreDetails(row) {
      const code = row;
      this.codeVoucher = code;
      this.showConfirmModal = true;
    },
    cancel() {
      this.showConfirmModal = false;
    },
    async acept() {
      const loader = this.$loading.show({ container: this.$refs.formContainer, canCancel: false });
      const response = await deleteVoucher(this.codeVoucher.substring(0, 14), this.user.company.stKey, this.codeVoucher.substring(14));
      loader.hide();
      if (response.hasErrors === false) {
        Vue.swal('', response.message, 'success');
        this.removerItem(this.codeVoucher.substring(0, 14));
        this.allvoucher -= 1;
        this.showConfirmModal = false;
      } else {
        Vue.swal('', 'Apenas Vouchers expirados podem ser excluídos! Esse voucher não será excluído!', 'warning');
        this.showConfirmModal = false;
      }
    },
    openCalender() {
      this.openCalenderbool = !this.openCalenderbool;
    },
    close() {
      this.isOpenModal = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    clearFilter() {
      const ele = document.getElementsByTagName('input');
      for (let i = 0; i < ele.length; i += 1) {
        ele[i].checked = false;
      }
      this.filter = StatusInfoVoucher.none;
    },
    resetForm() {
      this.form.reset();
      this.reset();
    },
    async onSubmit() {
      this.loading = true;

      if (this.infoVoucher.used === this.infoVoucher.avaliable) {
        this.$toast('Quantidade quota atingindo!');
        this.loading = false;
        this.resetForm();
        return;
      }

      const data: CreateVoucherBody = {
        tokenKey: this.user.company.stKey,
        cdUser: this.user.idUser,
        nameProducer: this.voucher.name,
        document: removeMaskDocument(this.voucher.document),
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        expirationDate: String(new Date(this.voucher.date).toISOString()),
      };
      const response = await createVoucher(data);
      const params = {
        tokenKey: this.user.company.stKey,
        to: this.email,
        subject: 'Programa de Reinserção e Monitoramento - Codigo Voucher',
        message: `Olá Produtor. Seja bem vindo ao Programa de Reinserção e Monitoramento!<br>
        Você foi convidado à participar da iniciativa e recebeu um voucher para se cadastrar na plataforma.<br>
        Esses são seus dados pessoais vinculados ao voucher:<br><br>
        Nome do produtor: ${this.voucher.name}<br>
        E-mail cadastrado: ${this.email}<br>
        Voucher: ${response.objectResult}, válido até o dia: ${this.voucher.date}<br><br>
        1 - Acesse a plataforma em: https://regenera-mt.agrotools.com.br/ e cadastre-se!<br>
        2 - Utilize seus dados pessoais para se cadastrar, alguns estão listados acima.<br>
        3 - Preencha o campo "Voucher" com o código de indicação, também listado acima.<br><br>
        Caso tenha alguma dúvida ou dificuldade para se cadastrar ou acessar a plataforma, entre em contato conosco pelo<br><br> ajuda@agrotools.com.br.<br><br>
        Atenciosamente,<br>
        Equipe PREM<br>
        <img src=${'https://ci4.googleusercontent.com/proxy/8VXcGgWKgnRWDvoO1ULFanruDLcoCVStB1eOdVwnCvNmdWUUNKVrTbErLmnC-ZkxTcINjM1fhaWew840ultpf0YT4dqaeeJzfqBifhaf_AW2jBUsFcK3iCseHW9TM7VRqhAoTOYZggb-KagRniDYXb0g9vRm76m17MihWEPNTc2fsP-p8pMDe2K3_L7bfEulpvPOGaudQhaYjSFyiw=s0-d-e1-ft#https://docs.google.com/uc?export=download&id=1Jvf12QCtJK5t0pgWs8wJSLXOCvcYKp7q&revid=0B4JMmF9tUiLRT3Y0WlV2RkIxZkR1WThPVEdtMjVrYTlVaVpRPQ'}/>`,
        isNotification: false,
        cdTerritory: 'Default',
        tag: 'Default',
        cdUser: 'Default',
      };
      if (response.hasError) {
        const { message } = response.error.response.data;
        this.loading = false;
        this.resetForm();

        if (message) {
          this.$toast.warning(message);
          return;
        }

        showError(response.error.response.data.message);
      } else {
        sendEmail(params);
      }

      this.close();
      this.$toast.success('Cadastro realizado com sucesso!');
      this.loading = false;
      this.requestVoucher({
        pageNumber: this.pagination.offset,
        pageSize: this.pagination.pageSize,
        calback: this.getAll,
      });
      this.pagination.total += 1;
    },
    setOffset(page: number) {
      this.pagination.offset = page;
      this.requestVoucher({
        pageNumber: this.pagination.offset,
        pageSize: this.pagination.pageSize,
        status: this.filter,
        calback: this.getAllVoucherPagination,
      });
    },
    async requestVoucher(params: VoucherRquestParams) {
      const data: GetVoucherParams = {
        tokenKey: this.user.company.stKey,
        cdUser: this.user.idUser,
        pageNumber: params.pageNumber,
        pageSize: params.pageSize,
        status: params.status,
      };
      const loader = this.$loading.show();
      await params.calback(data);
      loader.hide();
    },
    isArrayNotEmpty(arr: any) {
      return Array.isArray(arr) && arr.length > 0 ? arr : [];
    },
    isNumber(num: any) {
      return typeof num === 'number' ? num : 0;
    },
    async getAll(params: GetVoucherParams) {
      const response: any = await getAll(params, this.user.idUser, this.user.company.stKey, 'All');
      this.allvoucher = response.size;
      if (!response.hasErrors) {
        this.data = this.isArrayNotEmpty(response.vouchers);
        this.pagination.total = this.isNumber(response.size);
        this.infoVoucher.used = this.isNumber(response.used);
        this.infoVoucher.avaliable = this.isNumber(response.avaliable);
      }
    },
    async getStatusInative() {
      const data: any = {
        tokenKey: this.user.company.stKey,
        cdUser: this.user.idUser,
        pageNumber: 1,
        pageSize: 10,
      };
      const response: any = await getAllVoucherInative(data, this.user.idUser, this.user.company.stKey, 'Inativo');
      if (!response.hasErrors) {
        this.size = response.size;
        this.data = this.isArrayNotEmpty(response.vouchers);
        this.pagination.total = this.isNumber(this.size);
        this.infoVoucher.used = this.isNumber(response.used);
      }
    },
    removeNumbers(value) {
      return value.replace(/^[0-9]+$/, '');
    },
    removeSpecialCharacters(charactersString) {
      return charactersString.replace(/[^\w\s]/, '');
    },
    checkForSpecialCharacters(charactersString) {
      const specialCharactersRegex = /[^\w\s]/;
      return specialCharactersRegex.test(charactersString);
    },
    checkForSpecialCharactersNumber(charactersString) {
      const specialCharactersRegex = /^[0-9]/;
      return specialCharactersRegex.test(charactersString);
    },
    async getStatus() {
      const data: any = {
        tokenKey: this.user.company.stKey,
        cdUser: this.user.idUser,
        pageNumber: 1,
        pageSize: 10,
      };
      const response: any = await getAllVoucherAtive(data, this.user.idUser, this.user.company.stKey, 'Ativo');
      if (!response.hasErrors) {
        this.size = response.size;
        this.data = this.isArrayNotEmpty(response.vouchers);
        this.pagination.total = this.isNumber(this.size);
        this.infoVoucher.used = this.isNumber(response.used);
        this.infoVoucher.avaliable = this.isNumber(200);
      }
    },
    async getCadastration() {
      const data: any = {
        tokenKey: this.user.company.stKey,
        cdUser: this.user.idUser,
        pageNumber: 1,
        pageSize: 10,
      };
      const response: any = await getAllVoucherCadastration(data, this.user.idUser, this.user.company.stKey, 'All');
      if (!response.hasErrors) {
        this.size = response.size;
        this.data = this.isArrayNotEmpty(response.vouchers);
        this.pagination.total = this.isNumber(response.size - 1);
        this.infoVoucher.used = this.isNumber(response.used);
        this.infoVoucher.avaliable = this.isNumber(200);
      }
    },
    async getCadastrationPage() {
      const data: any = {
        tokenKey: this.user.company.stKey,
        cdUser: this.user.idUser,
        pageNumber: 1,
        pageSize: 10,
      };
      const response: any = await getAllVoucherReg(data);
      if (!response.hasErrors) {
        this.data = this.isArrayNotEmpty(response.vouchers);
        this.pagination.total = this.isNumber(response.size);
        this.infoVoucher.used = this.isNumber(response.used);
        this.infoVoucher.avaliable = this.isNumber(200);
      }
    },
    async getAllVoucherPagination(params: GetVoucherParams) {
      if (this.filter === StatusInfoVoucher.expired) {
        const response: any = await getAllVoucherInative(params, this.user.idUser, this.user.company.stKey, 'Inativo');
        if (!response.hasErrors) {
          this.size = response.size;
          this.data = this.isArrayNotEmpty(response.vouchers);
          this.pagination.total = this.isNumber(response.size);
          this.infoVoucher.used = this.isNumber(response.used);
          this.infoVoucher.avaliable = this.isNumber(200);
        }
      } else if (this.filter === StatusInfoVoucher.available) {
        const response: any = await getAllVoucherAtive(params, this.user.idUser, this.user.company.stKey, 'Ativo');
        if (!response.hasErrors) {
          this.size = response.size;
          this.data = this.isArrayNotEmpty(response.vouchers);
          this.pagination.total = this.isNumber(response.size);
          this.infoVoucher.used = this.isNumber(response.used);
          this.infoVoucher.avaliable = this.isNumber(200);
        }
      } else if (this.filter === StatusInfoVoucher.registered) {
        const response: any = await getAllVoucherCadastration(params, this.user.idUser, this.user.company.stKey, 'All');
        if (!response.hasErrors) {
          this.data = this.isArrayNotEmpty(response.vouchers);
          this.pagination.total = this.isNumber(this.size);
          this.infoVoucher.used = this.isNumber(response.used);
          this.infoVoucher.avaliable = this.isNumber(200);
        }
      } else if (this.filter === StatusInfoVoucher.none) {
        const response = await getAllVoucher(params);
        if (!response.hasErrors) {
          this.data = response;
        }
      }
    },
  },
  watch: {
    'voucher.name': function dateCaracters(newValue) {
      if (this.checkForSpecialCharacters(newValue)) {
        this.voucher.name = '';
      }
      if (this.checkForSpecialCharactersNumber(newValue)) {
        this.voucher.name = '';
      }
      this.removeSpecialCharacters(newValue);
      this.removeNumbers(newValue);
    },
    filter: {
      handler() {
        if (this.filter === StatusInfoVoucher.available) {
          this.requestVoucher({
            pageNumber: this.pagination.offset,
            pageSize: this.pagination.pageSize,
            status: StatusInfoVoucher.available,
            calback: this.getStatus,
          });
        } else if (this.filter === StatusInfoVoucher.expired) {
          this.requestVoucher({
            pageNumber: this.pagination.offset,
            pageSize: this.pagination.pageSize,
            status: StatusInfoVoucher.available,
            calback: this.getStatusInative,
          });
        } else if (this.filter === StatusInfoVoucher.registered) {
          this.requestVoucher({
            pageNumber: this.pagination.offset,
            pageSize: this.pagination.pageSize,
            status: StatusInfoVoucher.available,
            calback: this.getCadastration,
          });
        } else if (this.filter === StatusInfoVoucher.none) {
          this.requestVoucher({
            pageNumber: this.pagination.offset,
            pageSize: this.pagination.pageSize,
            status: this.filter === StatusInfoVoucher.none ? null : this.filter,
            calback: this.getAll,
          });
        }
      },
      immediate: true,
    },
  },
});
